import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5; // Position the label in the middle of the inner and outer radius
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"  // Set text anchor to 'middle' for horizontal centering
      alignmentBaseline="middle"  // Set alignment baseline to 'middle' for vertical centering
      fontSize="12px"
    >
      {`${(percent * 100).toFixed(1)}%`}
    </text>
  );
};


export const GraphStructure = ({ data }) => {
  return (
    <div className="flex pkp items-center">
      <PieChart width={400} height={300}>
        <Pie
          data={data}
          cx={"50%"}
          cy={"50%"}
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={120}
          innerRadius={40}
          paddingAngle={0}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    </div>
  );
};
